import {
  Avatar,
  Button,
  CircularProgress,
  Menu,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import { useAuthContext } from "contexts/AuthContext"
import { useThemeContext } from "contexts/ThemeContext"
import { styles } from "./GroupsButton.styles"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import { useTranslation } from "react-i18next"
import useApi from "modules/groups"
import EastIcon from "@mui/icons-material/East"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { NavLink } from "react-router-dom"
import { routes } from "common/navigationRoutes"
import { maxWidth600 } from "themes/default/breakpoints"

export default function GroupsButton() {
  const { t } = useTranslation()
  const { selectedGroupData, setSelectedGroupData } = useAuthContext()
  const { bgColor } = useThemeContext()
  const { getStudentGroups, setSelectedGroup, isFetching } = useApi()
  const [anchorEl, setAnchorEl] = useState(null)
  const [groups, setGroups] = useState([])
  const open = Boolean(anchorEl)
  const matches = useMediaQuery(maxWidth600)
  const theme = useTheme()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    if (open) {
      loadGroups()
    }
  }, [open])

  const loadGroups = async () => {
    getStudentGroups().then((response) => {
      if (response) {
        setGroups(response)
      }
    })
  }

  const changeClass = async (item) => {
    handleClose()
    const response = await setSelectedGroup({ groupId: item?.groupId })
    if (response?.status) {
      setSelectedGroupData(item)
      window.location.href = `${window.location.origin}${process.env.REACT_APP_MS_REDIRECT_URI}${routes.MISSIONS}`
    }
  }

  return (
    <React.Fragment>
      <Button
        sx={styles.groupSelectorButton}
        id="group-selector-btn"
        aria-controls={open ? "group-selector-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={
          <KeyboardArrowDownIcon sx={{ color: theme.palette.common.white }} />
        }
      >
        <Avatar src={selectedGroupData?.iconURL} sx={styles.avatar} />
        {!matches && (
          <Typography sx={styles.groupSelected}>
            {selectedGroupData?.name}
          </Typography>
        )}
      </Button>
      <Menu
        id="group-selector-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": `group-selector-btn`,
          },
          paper: {
            // elevation: 0,
            sx: {
              minWidth: 250,
              maxWidth: 400,
              width: "calc(100vw - 100px)",
              // border: "1px solid #d4d4d5",
              p: ".833em 1em",
              color: "rgba(0,0,0,.87)",
              boxShadow:
                "0 2px 4px 0 rgba(34,36,38,.12),0 2px 10px 0 rgba(34,36,38,.15)",
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .notification-btn": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 14,
                width: 10,
                height: 10,
                bgcolor: bgColor,
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          p={".5rem"}
        >
          <Typography variant="body1" color={theme.palette.common.black}>
            {t("Groups")}
          </Typography>
          <NavLink to={routes.GROUPS} rightIcon={<OpenInNewIcon />}>
            <Button
              variant="link"
              sx={styles.menuHeaderLink}
              startIcon={<OpenInNewIcon />}
              onClick={handleClose}
            >
              {t("View all groups")}
            </Button>
          </NavLink>
        </Stack>
        <Stack sx={styles.groupList}>
          {!isFetching && groups.length === 0 && (
            <CircularProgress
              sx={{
                color: theme.palette.primary.main,
                width: 50,
                height: 50,
                alignSelf: "center",
                my: 2,
              }}
              size={"large"}
            />
          )}
          {groups.map((group) => (
            <Stack
              key={group.groupId}
              sx={styles.grouptem}
              direction={"row"}
              onClick={() => changeClass(group)}
            >
              <Avatar src={group.iconURL} sx={styles.groupAvatar} />
              <Typography variant="body1" sx={styles.groupName}>
                {group.name}
              </Typography>
              <EastIcon sx={styles.groupButton} />
            </Stack>
          ))}
        </Stack>
      </Menu>
    </React.Fragment>
  )
}
